module.exports = __webpack_public_path__ + "img/T4-A-xs_1.afc4dfc8.png";